import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PageLayoutFree from '../../../components/common/PageLayout/PageLayoutFree';
import '../../../styles/SelectCoin/SelectCoin.css';
import { routerActions } from 'connected-react-router';
import { SelectCoin as i18n } from '../../../middlewares/i18n'
import * as multicryptoActions from '../../../actions/multicryptoActions';
import ButtonBS from '../../../components/common/ButtonBS';

import { track } from '../../../helpers/analytics';
import ChainCard from './ChainCard.jsx';

class SelectChain extends Component {

  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      currentPage: 0
    }
    this.handleCoinSelect = this.handleCoinSelect.bind(this);
  }

  componentDidMount() {
    this.setState({
      disabled: false
    });
  }

  handleCoinSelect(coin) {
    // Handle coin selection
    if (this.state.disabled) return;
    track('Chain Selected', {
      coin_type: coin.name,
      chain: coin.chain.name
    });
    this.setState({
      disabled: true
    }, () => {
      this.props.actions.multicrypto.setSelectedCoin(coin);
    });
  }

  render() {
    // Variants passed from SelectCoin via location.state
    const variants = (this.props.location && this.props.location.state && this.props.location.state.variants) || [];

    // Fallback: if none passed, attempt to derive from ticker param (not implemented) or show nothing.
    const allCoins = variants;

    const COINS_PER_PAGE = 6;
    const startIndex = this.state.currentPage * COINS_PER_PAGE;
    const coinsToShow = allCoins.slice(startIndex, startIndex + COINS_PER_PAGE);
    const hasMoreCoins = startIndex + COINS_PER_PAGE < allCoins.length;
    const hasPrevCoins = this.state.currentPage > 0;

    return (
      <PageLayoutFree phone={false}>
        <div className="select-coin-header">
          <div className='bs-logo'/>
          <div className='line' />
          <h1 className="bs-title">{`${i18n[this.props.i18n.language.current].selectChain} for ${this.props.location.state.variants[0].ticker}`}</h1>
        </div>
        <div className="chain-selection-container" key={this.state.currentPage}>
          {coinsToShow.map((coin) => {
            return (
              <ChainCard
                key={`${coin.chain.id}-${this.state.currentPage}`}
                coin={coin}
                chainLogo={`/assets/chains/${coin.chain.name.toUpperCase()}.png`}
                handleCoinSelect={() => this.handleCoinSelect(coin)}
              />
            )
          })}
        </div>
        {allCoins.length > 6 && (
        <div className="pagination-controls">
          <ButtonBS
            content={i18n[this.props.i18n.language.current].prev}
            className='pagination-button-coin-cards'
            disabled={!hasPrevCoins}
            onClick={() => this.setState(prevState => ({
              currentPage: Math.max(0, prevState.currentPage - 1)
            }))}
          />
          <span>Page {this.state.currentPage + 1} of {Math.ceil(allCoins.length / COINS_PER_PAGE)}</span>
          <ButtonBS
            content={i18n[this.props.i18n.language.current].next}
            className='pagination-button-coin-cards'
            disabled={!hasMoreCoins}
            onClick={() => this.setState(prevState => ({
              currentPage: prevState.currentPage + 1
            }))}
          />
        </div>
        )}
        <ButtonBS
          content={i18n[this.props.i18n.language.current].backToCoin}
          className='back-to-coin-button'
          onClick={() => this.props.actions.router.push('/select-coin')}
        />
      </PageLayoutFree>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      router: bindActionCreators(routerActions, dispatch),
      multicrypto: bindActionCreators(multicryptoActions, dispatch)
    }
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    rate: state.rate,
    multicrypto: state.multicrypto
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectChain);
